import { AnimatePresence, motion } from "framer-motion";
import React from "react";

const Backdrop = ({
  isOpen,
  onClose,
  zIndex = 50,
  closeOnOutsideClick = false,
  children,
}) => {
  const handleBackdropClick = (e) => {
    if (closeOnOutsideClick) {
      onClose();
    }
  };
  return (
    <div>
      <AnimatePresence mode="wait">
        {isOpen && (
          <div className="fixed inset-0 overflow-y-auto" style={{ zIndex }}>
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              onClick={handleBackdropClick}
              className="fixed inset-0 bg-[#000000]/80 transition-opacity flex justify-center items-center"
            >
              {/* <div className="w-16 h-16 border-[5px] border-gray-800 border-b-primary rounded-full animate-spin" /> */}
              {children}
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Backdrop;
